module.exports = __webpack_public_path__ + "img/fp4.985ad6ef.jpg";